import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { customer_activate, reset_customer_activate } from "../../actions/auth";

const BasicInfo = ({ customer }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const activate_portal = useSelector(
    (state) => state?.admin?.customer_activate
  );

  useEffect(() => {
    if (activate_portal?.data?.status) {
      dispatch(reset_customer_activate());
      toast.success((customer?.status === "active" ? "Deactivated" : "Activated") + " User");
      history.push("/admin/customers");
    }
    if (activate_portal?.data?.status === false) {
      toast.error(activate_portal?.data?.message);
      dispatch(reset_customer_activate());
    }
    // eslint-disable-next-line
  }, [activate_portal]);
  const details = {
    name: customer?.name,
    contact_no: customer?.phone,
    // alt_contact_no: "9898787879",
    email: customer?.email,
    country_of_origin: customer?.address,
  };
  // const spoc_details = {
  //   name: "Ramji",
  //   contact_no: "9898787879",
  //   email: "02nov@yopmail.com",
  // };
  const labels = {
    firstName: "First Name",
    name: "Name",
    lastName: "Last Name",
    contact_no: "Contact No.",
    alt_contact_no: "Alternate Contact No.",
    email: "Email",
    country_of_origin: "Country of origin",
  };
  return (
    <div>
      <div className="d-flex card">
        <div className="w50">
          <label>Customer</label>
          <div className="mtHalf">
            {Object.keys(details).map((ele) => {
              return (
                <div className="detail-row">
                  <span>{labels[ele]}</span>
                  <span>{details[ele]}</span>
                </div>
              );
            })}
          </div>
        </div>
        {/* <div className="w50">
          <label>OMNI Spoc Details</label>
          <div className="mtHalf">
            {Object.keys(spoc_details).map((ele) => {
              return (
                <div className="detail-row">
                  <span>{labels[ele]}</span>
                  <span>{spoc_details[ele]}</span>
                </div>
              );
            })}
          </div>
        </div> */}
      </div>
      <div className="flex-between card mt2">
        <div>
          <label>PORTAL ACCESS</label>
          <p>
            Enabling portal access gives the flexibility to the customer to
            place orders directly from E-Portal. A Welcome email will be
            triggered to the customer to set the portal password.
          </p>
        </div>
        <button
          className="enable-btn"
          onClick={() => {
            dispatch(
              customer_activate({
                email: localStorage.getItem("email"),
                status: customer?.status === "active" ? "deactivate" : "activate",
                customer_id: customer?.id,
              })
            );
          }}
        // disabled={customer?.status === "active"}
        >
          {customer?.status === "active" ? "Disable" : "Enable"} Access
        </button>
      </div>
    </div>
  );
};

export default BasicInfo;
